import React, { useMemo } from 'react';
import { Nullable } from 'global';
import { Stack, Typography } from '@mui/material';
import { NFAListingColumns } from './nfaListingConfig';
import { Listing } from 'components/shared/TableListing';
import { QuoteCalcNetFinanceAmount } from '../../../api/types';
import { NetFinanceAmountListingEntity } from '../../../types';

interface Props {
  netFinanceAmount: Nullable<QuoteCalcNetFinanceAmount>;
}

export const NetFinanceAmountListing = ({ netFinanceAmount }: Props) => {
  const tableData = useMemo<NetFinanceAmountListingEntity>(
    () => ({
      fees: netFinanceAmount?.fees ?? 0,
      taxes: netFinanceAmount?.taxes ?? 0,
      hardCost: netFinanceAmount?.hardCost ?? 0,
      softCost: netFinanceAmount?.softCost ?? null,
      netFinanceAmount: netFinanceAmount?.netFinanceAmount ?? 0,
    }),
    [netFinanceAmount]
  );

  return (
    <Listing<NetFinanceAmountListingEntity>
      tableData={[tableData]}
      columns={NFAListingColumns}
      actionPanelTop={() => (
        <Stack>
          <Typography variant="h6" component="span">
            Net Finance Amount
          </Typography>
        </Stack>
      )}
    />
  );
};
